import React from 'react';
import { NavLink } from 'react-router-dom';
import './CSS/Navbar.css'

const NavBar = () => {
  return(
    
      <>  
      <div className="NavBar">

<nav>

<NavLink exact to={"/"}>
<img src="https://pluspng.com/img-png/pokemon-logo-png-pokemon-logo-png-2000.png"  className="align-center" alt=""  />


</NavLink>
                <NavLink to={"/pokemon"}>Pokemon Selector</NavLink>
                <NavLink to={"/pokemon/:name"}>Type</NavLink>
</nav>
      </div>
    </>
  )
}

export default NavBar; 